import { autoinject, computedFrom, customElement } from 'aurelia-framework';
import { ToastService } from 'framework/aurelia_tools/toast-service';
import { ToastOptions } from './bs-toast-item';

@autoinject
@customElement('bs-toast-list')
export class ToastList {
  constructor(private toastService: ToastService<ToastOptions>) {}

  @computedFrom('toastService.messages')
  get messages() {
    return this.toastService.messages;
  }
}
